import { CHECK_GIFTCARD_BALANCE, CHECKBALANCE_SUCCESS, CHECKBALANCE_API_ERROR, CLEAR_GIFTCARD_BALANCE, RESET_GIFTCARDBALANCE, GET_GIFTCARD_DETAILS, GET_GIFTCARD_DETAILS_SUCCESS, GET_GIFTCARD_DETAILS_FAILURE } from '../../constants';
const initialState = {
    response: {},
    error: false,
    isGiftCardCheckLoading: false,
    balanceFetchSuccess: false,
    isGiftCardDetailsLoading: false,
    detailsFetchSuccess: false
};
const createBalanceReducer = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_GIFTCARD_BALANCE:
            return {
                ...state,
                isGiftCardCheckLoading: true,
                balanceFetchSuccess: false,
            };
        case CHECKBALANCE_SUCCESS:
            return {
                ...state,
                response: action.response,
                error: false,
                isGiftCardCheckLoading: false,
                balanceFetchSuccess: true,
            };
        case CHECKBALANCE_API_ERROR:
            return {
                ...state,
                error: true,
                isGiftCardCheckLoading: false,
                balanceFetchSuccess: false,
            };
        case GET_GIFTCARD_DETAILS:
            return {
                ...state,
                isGiftCardDetailsLoading: true,
                detailsFetchSuccess: false,
            };
        case GET_GIFTCARD_DETAILS_SUCCESS:
            return {
                ...state,
                response: action.response,
                error: false,
                isGiftCardCheckLoading: false,
                detailsFetchSuccess: true,
            };
        case GET_GIFTCARD_DETAILS_FAILURE:
            return {
                ...state,
                error: true,
                isGiftCardDetailsLoading: false,
                detailsFetchSuccess: false,
            };
        case CLEAR_GIFTCARD_BALANCE:
            return {
                ...state,
                error: false,
                isGiftCardCheckLoading: false,
                response: {},
                balanceFetchSuccess: false,
            };
        case RESET_GIFTCARDBALANCE:
            return {
                ...state,
                response: {},
                error: false,
            };
        default:
            return state;
    }
};
export default createBalanceReducer;
